import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  private apiUrl = environment.baseApiPCv2;

  constructor(private http: HttpClient) {}

  uploadDocuments(form: any) {
    const payload = {
      patient: {
        id: form.patient.id ?? null,
        name: form.patient.name ?? '',
        firstName1: form.patient.firstName1 ?? '',
        firstName2: form.patient.firstName2 ?? '',
        lastName1: form.patient.lastName1 ?? '',
        lastName2: form.patient.lastName2 ?? '',
        email: form.patient.email ?? '',
        phone: form.patient.phone ?? '',
        gender: form.patient.gender ?? '',
        birthDate: form.patient.birthDate ?? '',
        rut: form.patient.rut ?? '',
      },
      attachments: form.attachments ?? [],
      center: {
        cod: form.center.cod ?? '',
        utm: form.center.utm ?? '',
        idCentro: form.center.idCentro ?? '',
      },
      recaptchaToken: form.recaptchaToken ?? '',
    };

    return this.http.post(this.apiUrl + '/almacenamiento-s3/v1/ordenes', payload, {
      headers: { ['Content-Type']: 'application/json' },
    });
  }
}
